export enum GapPriorityEnum {
  Critical = "critical", // 90-100th percentile
  High = "high", // 75-90th percentile
  Medium = "medium", // 50-75th percentile
  Low = "low", // 25-50th percentile
  Minimal = "minimal" // 25th percentile
}
